import { color } from '@creditornot/cb-ingredients/design-tokens';
import styled from 'styled-components';

export const EntityActionItemTitle = styled.div<{ isSelected?: boolean }>`
  display: flex;
  gap: 8px;
  align-self: stretch;
  justify-content: space-between;
  padding: 6px 8px;
  border-radius: 8px;
  align-items: center;
  background-color: ${props => (props.isSelected ? color.bgFillBrand : 'transparent')};
  color: ${props => (props.isSelected ? color.textOnBgFillBrand : color.text)};
  fill: ${props => (props.isSelected ? color.textOnBgFillBrand : color.text)};
  cursor: pointer;

  &:hover {
    background-color: ${color.bgSurfaceHovered};
    color: ${color.textHovered};
    fill: ${color.textHovered};
  }

  &:active {
    background-color: ${color.bgSurfacePressed};
    color: ${color.textPressed};
    fill: ${color.textPressed};
  }
`;
